module.exports = __webpack_public_path__ + "static/media/icon_nav_on_invoice.87076287.svg";